import * as yup from "yup";
import { validationNotEmpty, validationWithoutSpace, } from "./defaultValidations";

export default yup.object({
  keyName: validationNotEmpty("Key Name"),
  algorithm: validationNotEmpty("Algorithm"),
  policyDescription: validationNotEmpty("Description"),
  keyLength: validationNotEmpty("Key Length"),
});